<template>

  <div class="form-group">

    <TemplateFeedback ref="filterFeedback" />

    <TemplateAlert 
      v-show="filterData && filterData.length === 0"
      v-bind:message="filterEmptyMessage || 'No data available.'"
      v-bind:class="'alert-warning'" />

    <div v-show="filterData && filterData.length > 0">

      <slot />

      <select 
        ref="filter"
        v-bind:id="filterId"
        class="form-control" 
        v-on:input="onFilterDataChange"
        v-bind="filterDisable ? Object.assign({'disabled': 1}, filterAttr) : filterAttr"
        v-model="filterValue">
        <option 
          v-for="dataItem in filterData" 
          v-bind:key="dataItem.id"
          v-bind:value="formatFilterOptionValue(dataItem)">
          {{ formatFilterOptionText(dataItem) }}
        </option>
      </select>

    </div>

  </div>
  
</template>

<script>

import TemplateAlert from "@/components/Template/TemplateAlert";
import TemplateFeedback from "@/components/Template/TemplateFeedback";

import helper from "@/components/Utility/Helper"

export default {
  name: "AppFilter",
  props: ['filterEmptyMessage', 'filterAttr', 'filterKey'],
  components: {
    TemplateAlert,
    TemplateFeedback,
  },
  data() {
    return {
      filterId: null,
      filterFirstLoad: true,

      filterData: null,
      filterValue: undefined,
      filterDisable: null,
    };
  },
  // watch: {
  //   filterValue: function (newValue, oldValue) {
  //     console.log('filterValue oldValue', oldValue);
  //     console.log('filterValue newValue', newValue);
  //   }
  // },
  mounted() {
    this.filterId = "jt_filter_" + this._uid;

    this.$nextTick(() => {
      $('#' + this.filterId).chosen();
      $('#' + this.filterId).on('change', (evt, params) => {
        if(params) {
          this.filterValue = params.selected;
        } else {
          this.filterValue = '';
        }
        this.onFilterDataChange();
      });
	    $('#' + this.filterId + '_chosen').css('width', '100%');
    })
  },
  methods: {
    setFilterLoading(message) {
      this.$refs['filterFeedback'].setFeedbackLoading(message);
      this.filterData = null;
    },
    setFilterError(error) {
      // TODO kw skip loading filtering fields if user click search before all filter load complete
      // fix - not show/allow search before filter complete
      this.$refs['filterFeedback'].setFeedbackError(error || '');
      this.filterData = null;
    },
    setFilterData(data) {
      if(data === null) {
        this.filterValue = null;
      }

      this.$refs['filterFeedback'].setFeedbackMessage(null);
      this.filterData = data;
      this.filterFirstLoad = false;

      this.$nextTick(() => {
	      $('#' + this.filterId).trigger("chosen:updated");
      })
    },
    setFilterValue(filterValue) {
      this.filterValue = filterValue;

      this.$nextTick(() => {
	      $('#' + this.filterId).trigger("chosen:updated");
      })
    },
    setFilterDisable(filterDisable) {
      this.filterDisable = filterDisable;

      this.$nextTick(() => {
	      $('#' + this.filterId).trigger("chosen:updated");
      })
    },

    setFilterDataWithDefault(filterData) {
      try {
        filterData = filterData.sort((a,b) => b['createDate'] - a['createDate']);
      } catch(e) {
      }
      
      // TODO kw looks dumb
      this.setFilterValueDefault(filterData);
      this.setFilterData(filterData);
    },
    setFilterDataWithValueIfFirstLoad(filterData, filterValue) {
      try {
        filterData = filterData.sort((a,b) => a['createDate'] - b['createDate']);

        try {
          if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology' && this.filterKey !== 'carparkID') {
            filterData = filterData.sort((a,b) => b['createDate'] - a['createDate']);
          }
        } catch(e) {
        }
      } catch(e) {
      }

      if(this.filterFirstLoad) {
        if(filterValue && filterData.some(k => String(k.id || k) === String(filterValue))) {
          this.filterValue = filterValue;
        // } else if(window.location.href.includes('localhost')) {
        //   let hardcodeValue;
        //   if(this.filterKey === 'carparkID') {
        //     hardcodeValue = 940;
        //   } else if(this.filterKey === 'zoneID') {
        //     hardcodeValue = 575;
        //   } else if(this.filterKey === 'licenseID') {
        //     // hardcodeValue = 208;
        //   }

        //   if(filterData.some(k => String(k.id) === String(hardcodeValue))) {
        //     this.filterValue = hardcodeValue;
        //   } else {
        //     this.setFilterValueDefault(filterData);
        //   }
        } else {
          this.setFilterValueDefault(filterData);
        }
      } else {
        this.setFilterValueDefault(filterData);
      }
      this.setFilterData(filterData);
    },
    setFilterValueDefault(filterData) {
      this.filterValue = filterData[0] ? this.formatFilterOptionValue(filterData[0]) : null;
    },

    formatFilterOptionValue: (filterDataItem) => filterDataItem.id || (typeof filterDataItem === 'string' ? filterDataItem : ''),
    formatFilterOptionText: (filterDataItem) => filterDataItem.name || (typeof filterDataItem === 'string' ? filterDataItem : ''),

    onFilterDataChange() {
      setTimeout(() => {
        if(this.filterKey) {
          history.replaceState({}, document.title, helper.updateQueryString(window.location.href, this.filterKey, this.filterValue === undefined ? '' : this.filterValue));
        }
        if(this.filterFirstLoad) return;
        this.$emit('filter-data-change', this.filterValue);
      }, 100)
    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/App/AppFilter.vue